import ExcelJS from "exceljs";
import { excelCellValueToString } from "./importTemporal";

export { excelCellValueToString };

function maxUsedColumn(sheet: ExcelJS.Worksheet): number {
  let max = 0;
  sheet.eachRow((row) => {
    row.eachCell({ includeEmpty: false }, (_cell, colNumber) => {
      if (colNumber > max) max = colNumber;
    });
  });
  return max;
}

/**
 * Reads the first worksheet of an .xlsx workbook as a header row plus string rows.
 * Skips wholly empty rows. Matches {@link parseCsv} shape for import pipelines.
 */
export async function parseXlsxFirstSheet(buffer: ArrayBuffer): Promise<{
  headers: string[];
  rows: string[][];
}> {
  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(buffer);
  const sheet = workbook.worksheets[0];
  if (!sheet) return { headers: [], rows: [] };

  const colCount = maxUsedColumn(sheet);
  if (colCount === 0) return { headers: [], rows: [] };

  const matrix: string[][] = [];
  sheet.eachRow((row) => {
    const cells: string[] = [];
    for (let c = 1; c <= colCount; c++) {
      cells.push(excelCellValueToString(row.getCell(c)));
    }
    if (cells.every((s) => s === "")) return;
    matrix.push(cells);
  });

  if (matrix.length === 0) return { headers: [], rows: [] };
  return { headers: matrix[0], rows: matrix.slice(1) };
}
